import React, {useState, useEffect} from 'react';
import importScript from '../../hooks/importScript';
import { Spinner } from './Spinner';

const QRCode = ({url}) =>{
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        if(url.length>0){
          importScript('/scripts/qrcode.min.js', init, window.QRCode);
        }
    }, [url])

    const init = () =>{
        const QR_CODE = new window.QRCode("qrcode", {
          text: window.location.origin + url,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: window.QRCode.CorrectLevel.L,
        });
        setLoading(false);
    }

    return(
        <>
            <div id="qrcode"/>
            {loading ? <Spinner/> : null}
        </>
    )
}

export default QRCode;